import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkoutStatus } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { track } from "../lib/analytics";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking"); // checking | success | failed
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("failed"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await checkoutStatus(sid);
        if (r.payment_status === "paid") {
          setState("success");
          track("paid_conversion", { package: r.package_id });
          await refresh();
          toast.success("Payment successful — your account has been upgraded!");
          return;
        }
        if (r.status === "expired" || attempts > 12) { setState("failed"); return; }
      } catch (e) {
        if (attempts > 12) { setState("failed"); return; }
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-8 text-center" data-testid="billing-success">
      {state === "checking" && (<><Loader2 className="animate-spin text-oxford mb-4" size={32} /><h1 className="font-serif text-3xl">Confirming your payment…</h1><p className="text-muted-foreground mt-2">This only takes a moment.</p></>)}
      {state === "success" && (<><CheckCircle2 className="text-[#16A34A] mb-4" size={44} /><h1 className="font-serif text-4xl">You're all set!</h1><p className="text-muted-foreground mt-2">Your account has been upgraded.</p>
        <button onClick={() => navigate("/")} data-testid="success-continue-btn" className="mt-6 bg-oxford text-white px-6 py-3 text-sm hover:bg-[#2C5282] transition-colors">Start a new examination</button></>)}
      {state === "failed" && (<><XCircle className="text-[#E11D48] mb-4" size={44} /><h1 className="font-serif text-3xl">Payment not completed</h1><p className="text-muted-foreground mt-2">No charge was made, or the session expired.</p>
        <button onClick={() => navigate("/pricing")} data-testid="success-retry-btn" className="mt-6 bg-oxford text-white px-6 py-3 text-sm hover:bg-[#2C5282] transition-colors">Back to pricing</button></>)}
    </div>
  );
}
